import { MARKETING_BANNER_VIEW } from './types';

export const triggerMarketingBannerIsViewed = (placement, groupId) => ({
  type: MARKETING_BANNER_VIEW,
  placement,
  groupId,
});
